export {
  Fieldset,
  type FieldsetProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Fieldset';
